


































import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "ctti-game-modal-component",
})
export default class CttiGameModalComponent extends Vue {
  showGame = false;
  mounted() {}
  get active(): boolean {
    return this.$store.getters["SystemStore/getCttiGameModal"];
  }
  cancel() {
    this.$store.dispatch("SystemStore/setCttiGameModalAction", false);
  }
  accept() {
    this.showGame = true;
  }
}
